/**
 * Hook simple pour récupérer la liste des clients
 * Utilisé dans les modals de projet pour sélectionner un client
 */

import { useQuery } from '@tanstack/react-query';
import { clientsAPI } from '@/utils/clientsAPI';

export function useClients(companyId: string) {
  return useQuery({
    queryKey: ['clients', companyId],
    queryFn: async () => {
      if (!companyId) return [];
      const response = await clientsAPI.getAll({ activeOnly: true, limit: 200 });
      return response.clients;
    },
    enabled: !!companyId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
